import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/user/admin.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-12" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4 border-end" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "profile-title" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = {
  class: "flex-grow-1",
  style: {"margin-left":"10px"}
}
const _hoisted_11 = { class: "col-md-8" }
const _hoisted_12 = { class: "table table-borderless" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = { class: "table card-table table-vcenter text-nowrap" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table card-table table-vcenter text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddRoleModal = _resolveComponent("AddRoleModal")!
  const _component_AddPointVenteModal = _resolveComponent("AddPointVenteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "card",
        ref: "userForm",
        onSubmit: _ctx.editUser,
        "validation-schema": _ctx.userSchema,
        "initial-values": _ctx.userForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "card-title mb-0" }, "Détails de l'utilisateur", -1)),
            _createVNode(_component_router_link, {
              to: "/utilisateurs/liste-utilisateur",
              class: "btn btn-primary transition border-0 lh-1 fw-medium",
              style: {"position":"absolute","right":"10px","top":"10px"}
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1" }, null, -1),
                _createTextVNode(" Retour ")
              ])),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-options" }, [
              _createElementVNode("a", {
                class: "card-options-collapse",
                href: "#",
                "data-bs-toggle": "card-collapse"
              }, [
                _createElementVNode("i", { class: "fe fe-chevron-up" })
              ]),
              _createElementVNode("a", {
                class: "card-options-remove",
                href: "#",
                "data-bs-toggle": "card-remove"
              }, [
                _createElementVNode("i", { class: "fe fe-x" })
              ])
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "mb-3" }, "Profil utilisateur", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[3] || (_cache[3] = _createElementVNode("img", {
                        class: "img-70 rounded-circle",
                        alt: "",
                        src: _imports_0
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.user?.nom) + " " + _toDisplayString(_ctx.user?.prenom), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.user?.email), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "mb-3" }, "Informations générales", -1)),
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("tbody", null, [
                    (_ctx.user?.nom)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                          _cache[5] || (_cache[5] = _createElementVNode("td", { class: "fw-medium" }, "Nom et prénom :", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.user?.nom) + " " + _toDisplayString(_ctx.user?.prenom), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.user?.telephone)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                          _cache[6] || (_cache[6] = _createElementVNode("td", { class: "fw-medium" }, "Téléphone :", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.user?.telephone), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.user?.email)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _cache[7] || (_cache[7] = _createElementVNode("td", { class: "fw-medium" }, "Email :", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.user?.email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.user?.sexe)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                          _cache[8] || (_cache[8] = _createElementVNode("td", { class: "fw-medium" }, "Sexe :", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.user?.sexe), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("div", { class: "card-title" }, [
            _createElementVNode("h4", null, "Rôle (s) affecté (s)à l'utilisateur")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Description"),
                  _createElementVNode("th", null, "Date d'affectation")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData?.userRoles, (rle, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(rle?.role?.description), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(rle?.dateAffectation)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("div", { class: "card-title" }, [
            _createElementVNode("h4", null, "Point (s) de vente(s) affectés à l'utilisateur")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Nom Point Vente"),
                  _createElementVNode("th", null, "Date")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user?.userpointventes || [], (pv, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(pv?.pointvente?.nomPointVente), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(pv?.createdAt)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddRoleModal, {
      selectedUser: _ctx.selectedUser,
      onClose: _ctx.reloadUserData,
      onGetAllUsers: _ctx.reloadUserData
    }, null, 8, ["selectedUser", "onClose", "onGetAllUsers"]),
    _createVNode(_component_AddPointVenteModal, {
      selectedUser: _ctx.selectedUser,
      onClose: _ctx.reloadUserData,
      onGetAllUsers: _ctx.reloadUserData
    }, null, 8, ["selectedUser", "onClose", "onGetAllUsers"])
  ]))
}